import { useState, useEffect } from "react";
import { instance } from "../../components/AxiosClient";

const comCode = process.env.REACT_APP_COM_CODE;

const getLotParkList = async (payload) => {
  try {
    const response = await instance.post(
      `/v1/container/manager/company/${comCode}/getSelectContract`,
      payload
    );

    if (response.status === 200) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {}
};

const getQueueuStatus = async () => {
  try {
    const response = await instance.get(
      `/v1/container/manager/company/${comCode}/getSelectContract`);

    if (response.status === 200) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {}
};

const getConvertUoM = async (id) => {
  try {
    const response = await instance.get(`/v5/item/manager/company/${comCode}/web/uomconvert/itemmaster/${id}`);
    return response;
  } catch (error) {
    return error.response;
  }
};

const getListItemNew = async (payload) => {
  try {
    const response = await instance.post(`/v5/item/manager/company/${comCode}/web/itemrecentlylog/searchitemmaster`, payload);
    return response;
  } catch (error) {
    return error.response;
  }
};

const getViewQueue = async (id) => {
  try {
    const response = await instance.get(`/v5/order/manager/company/${comCode}/web/deliveryorder/${id}?parcelDetail=true`);
    return response;
  } catch (error) {
    return error.response;
  }
};

const createUoM = async (body) => {
  try {
    const response = await instance.post(`/v5/item/manager/company/${comCode}/web/uom`, body);
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (error) {
    return error.responase;
  }
}

const createConvertUoM = async (body) => {
  try {
    const response = await instance.post(`/v5/item/manager/company/${comCode}/web/uomconvert/create`, body);
    if (response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return error.response;
  }
}

const getCustomerQueue = async (body) => {
  try {
    const response = await instance.post(`/v1/container/manager/company/${comCode}/get-select-contract-market`, body);
    if (response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return error.response;
  }
}




export { getLotParkList , getQueueuStatus,getListItemNew,getConvertUoM,getViewQueue,createUoM,createConvertUoM,getCustomerQueue};
